export class ObservationDTO {
  lineNo: number;
  type: string;
  value: string;
  valueType: string;
  effectiveDate: string;
}
